import lazysizes from 'lazysizes';
import 'lazysizes/plugins/noscript/ls.noscript';
import ComponentHelper from './components/00_utilities/helpers/ComponentHelper';
import LinkFocusHelper from './components/00_utilities/helpers/LinkFocusHelper';
import ScrollToHelper from './components/00_utilities/helpers/ScrollToHelper';

const componentHelper = new ComponentHelper();

/* eslint-disable */
const __svg__ = { path: './svg/*.svg', name: 'Icons/icons.svg', filename: svgFileName };
require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);

if (__devMode__) {
    __webpack_public_path__ = 'http://localhost:8085/assets/';
}
/* eslint-enable */

window.addEventListener('load', () => {
    window.youtubePlayers = [];

    componentHelper.initializePage();
    LinkFocusHelper.handleHashLink();
    ScrollToHelper.initializeAnchorLinks(lazysizes);
});

/**
 * Check for hot module replacement and use it if possible
 */
if (module.hot) {
    module.hot.accept();
}
